import { render } from "./WidgetBarChart.vue?vue&type=template&id=5f7fe448"
import script from "./WidgetBarChart.vue?vue&type=script&lang=js"
export * from "./WidgetBarChart.vue?vue&type=script&lang=js"

import "./WidgetBarChart.vue?vue&type=style&index=0&id=5f7fe448&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__